import React, { Component } from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import {connect} from 'react-redux'

@connect(
    state => ({
        activeCategory: state.categories.activeCategory,
        activeSubcategory: state.categories.activeSubcategory,
        activeCheckpoint: state.categories.activeCheckpoint
    })
)
export default class DroppableContext extends Component {

    render() {

        const {
            children,
            droppableId,
            activeCategory,
            activeSubcategory,
            activeCheckpoint
        } = this.props
        const isDragDisabled = (type, elem) => {
            switch(type) {
                case 'category':
                    return !!activeCategory && activeCategory.id === elem.props.category.id
                case 'subcategory':
                    return !!activeSubcategory && activeSubcategory.id === elem.props.category.id
                case 'checkpoint': 
                    return !!activeCheckpoint && activeCheckpoint.id === elem.props.checkpoint.id
                case 'measure':
                    return !!elem.props.measure.changed
                default:
                    return false
            }
        }
        return (
            <Droppable droppableId={droppableId} type={droppableId}>
                {
                    (provided) => (
                        <div ref={provided.innerRef}>
                            {
                                children.map(
                                    (child, index) =>
                                        <Draggable
                                            key={`${droppableId}_${index}`}
                                            draggableId={`${droppableId}_${index}`}
                                            index={index}
                                            isDragDisabled={isDragDisabled(droppableId, child)}
                                        >
                                            {
                                                (provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        {child}
                                                    </div>
                                                )
                                            }
                                        </Draggable>
                                )
                            }
                            {provided.placeholder}
                        </div>
                    )
                }
            </Droppable>
        )
    }
}